import React from 'react'
import { Spin } from "antd";
import './styles.css'

export default ({ loading = false, tip = "กำลังโหลด...", children, styles = {} }) => {
  return <Spin tip={tip} size="default" spinning={loading} style={{ ...styles }}>{children}</Spin>
}